import classnames from 'classnames';
export default function buttonClasses(_ref) {
  var className = _ref.className,
      style = _ref.style,
      pristine = _ref.pristine,
      invalid = _ref.invalid,
      submitting = _ref.submitting;
  return classnames("button-".concat(style), {
    'is-disabled': pristine || invalid,
    'in-progress': submitting
  }, className);
}